export default "__VITE_ASSET__ad020fe4__"